import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import WindEnergy from "./pages/WindEnergy";
import SolarEnergy from "./pages/SolarEnergy";
import HowItWorks from "./pages/HowItWorks";
import Packages from "./pages/Packages";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import Community from "./pages/Community";
import DashboardPreview from "./pages/DashboardPreview";
import WalletPayout from "./pages/WalletPayout";
import AffiliateNetwork from "./pages/AffiliateNetwor";
import TargetRewards from "./pages/TargetRewards";
import SecurityCompliance from "./pages/SecurityCompliance";
import TermsPage from "./pages/TermsPage";
import Privacy from "./pages/Privacy";
import NotFound from "./pages/NotFound";
import Login from "./pages/auth/Login";
import AdminLogin from "./pages/auth/AdminLogin";
import Register from "./pages/auth/Register";
import AdminDashboard from "./pages/admin/Dashboard";
import UserDashboard from "./pages/user/UserDashboard";
import RequireAuth from "./components/RequireAuth";
import ScrollTopManager from "./components/ScrollTopManager";
import ScrollToTop from "./components/ScrollToTop"; // Import the new component

const App = () => (
  <BrowserRouter>
    <ScrollToTop /> {/* Add this line - it will handle scrolling on route changes */}
    <ScrollTopManager />
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/wind-energy" element={<WindEnergy />} />
        <Route path="/solar-energy" element={<SolarEnergy />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/community" element={<Community />} />
        <Route path="/dashboard-preview" element={<DashboardPreview />} />
        <Route path="/wallet" element={<WalletPayout />} />
        <Route path="/affiliate" element={<AffiliateNetwork />} />
        <Route path="/targets" element={<TargetRewards />} />
        <Route path="/security" element={<SecurityCompliance />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/register" element={<Register />} />
      </Route>
      <Route
        path="/dashboard"
        element={
          <RequireAuth role="admin">
            <AdminDashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/user-dashboard/*"
        element={
          <RequireAuth role="user">
            <UserDashboard />
          </RequireAuth>
        }
      />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </BrowserRouter>
);

export default App;